import Vue from "vue";
import VueI18n from "vue-i18n";
import config from "./config/config";

Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

const dateTimeFormats = {
  en: {
    short: {
      year: "numeric",
      month: "short",
      day: "numeric"
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric",
      weekday: "short",
      hour: "numeric",
      minute: "numeric",
      hour12: true
    },
    timeOfDay: {
      hour: "numeric",
      minute: "numeric",
      hour12: true
    }
  },
  nb: {
    short: {
      year: "numeric",
      month: "short",
      day: "numeric"
    },
    long: {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "short",
      hour: "numeric",
      minute: "numeric"
    },
    timeOfDay: {
      hour: "numeric",
      minute: "numeric",
      hour12: false
    }
  },
  nn: {
    short: {
      year: "numeric",
      month: "short",
      day: "numeric"
    },
    long: {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "short",
      hour: "numeric",
      minute: "numeric"
    },
    timeOfDay: {
      hour: "numeric",
      minute: "numeric",
      hour12: false
    }
  },
  da: {
    short: {
      year: "numeric",
      month: "short",
      day: "numeric"
    },
    long: {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "short",
      hour: "numeric",
      minute: "numeric"
    },
    timeOfDay: {
      hour: "numeric",
      minute: "numeric",
      hour12: false
    }
  },
  se: {
    short: {
      year: "numeric",
      month: "short",
      day: "numeric"
    },
    long: {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "short",
      hour: "numeric",
      minute: "numeric"
    },
    timeOfDay: {
      hour: "numeric",
      minute: "numeric",
      hour12: false
    }
  }
};

const i18n = new VueI18n({
  locale: config.getDefaultLanguage() || "en",
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
  messages: loadLocaleMessages(),
  dateTimeFormats: dateTimeFormats
});

export default i18n;
